import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

const options = [
  { label: 'Subscribe Newsletter', value: "subscribe" },
  { label: 'Go to Memberships', value: "memberships" },
  { label: 'Go to Events', value: "events" },
  { label: 'Go to Next Event', value: "events/next" },
  { label: 'Go to Store', value: "store" },
  { label: 'Go to Custom URL', value: "custom" },
];

const CtaButtonActionEditor = ({value, onChange}) => {
  const [isCustomUrl, setIsCustomUrl] = useState(value && !options.some(opt => opt.value === value));

  const customUrlRef = useRef(null);

  const handleChange = (event) => {
    const newValue = event.target.value;
    if (newValue === 'custom') {
      setIsCustomUrl(true);
      onChange({target: {name: "custom_cta_action", value: ''}});
    } else {
      setIsCustomUrl(false);
      onChange({target: {name: "custom_cta_action", value: newValue}});
    }
  };

  const handleCustomUrlChange = (event) => {
    onChange({target: {name: "custom_cta_action", value: event.target.value}});
  };

  useEffect(() => {
    if (isCustomUrl && customUrlRef.current) {
      customUrlRef.current.focus();
    }
  }, [isCustomUrl]);

  return (
    <>
      <TextField
        select
        fullWidth
        size='small'
        color='warning'
        label="Action Type"
        value={isCustomUrl ? 'custom' : value}
        onChange={handleChange}
        sx={{ mb: 2 }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      
      {isCustomUrl && (
        <TextField 
          fullWidth 
          size='small'
          color='warning' 
          label="Custom URL"
          placeholder="https://example.com/tickets"
          value={value || ''}
          onChange={handleCustomUrlChange}
          sx={{ mb: 2 }}
          inputRef={customUrlRef}
        />
      )}
    </>
  );
};

CtaButtonActionEditor.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func
};

export default CtaButtonActionEditor;